module.exports = __webpack_public_path__ + "html/block-page-break.component.html";